import React, { useEffect, useState } from 'react';
import { ApiController } from 'apiServices/apiController';
import { LmsListModel } from 'apiServices/controllers/lms';
import { LmsOverview } from './lms-overview';

type LmsAjaxFetch = {
  isFetched: boolean;
  loading: boolean;
  error: boolean;
  data: LmsListModel | null;
};

export const LmsAjax = () => {
  const [{
    isFetched, loading, error, data,
  }, setLmsAjaxFetch] = useState<LmsAjaxFetch>({
    isFetched: false,
    loading: true,
    error: false,
    data: null,
  });

  useEffect(() => {
    if (!isFetched) {
      setLmsAjaxFetch((prev) => ({ ...prev, isFetched: true }));

      try {
        const fetchLmsList = async () => {
          const response = await ApiController.Lms.getLmsList();

          return setLmsAjaxFetch({
            isFetched: true,
            loading: false,
            error: false,
            data: response,
          });
        };

        fetchLmsList();
      } catch (error) {
        setLmsAjaxFetch({
          isFetched: true, loading: false, error: true, data: null,
        });
      }
    }
  }, [isFetched]);

  if (!data || loading) {
    return <>Laden...</>;
  }

  if (error) {
    return <>Kon lms'en niet ophalen</>;
  }

  return <LmsOverview dataObject={data} />;
};
